export default __webpack_public_path__ + "static/booth-2b89ffa711153ee9537e53065e20fe80.png";